import { render, staticRenderFns } from "./AvatarDescription.vue?vue&type=template&id=6a3e6628&scoped=true&"
import script from "./AvatarDescription.vue?vue&type=script&lang=ts&"
export * from "./AvatarDescription.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarDescription.vue?vue&type=style&index=0&id=6a3e6628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3e6628",
  null
  
)

export default component.exports